import axios from '@api/axiosInstance.js'

export const fetchMarketTrend = async (payload = {}) => {
  const res = await axios.post(`/chart/trends`, payload)
  return res.data
}

export const fetchMetrics = async (payload = {}) => {
  const res = await axios.post(`/chart/metrics`, payload)
  return res.data
}

export const fetchBanner = async (payload = {}) => {
  const res = await axios.post(`/banner/ads`, payload)
  return res.data
}

export const fetchCoinInfo = async (payload = {}) => {
  const res = await axios.post(`/coin/top`, payload)
  return res.data
}

export const fetchRankByAll = async (payload = {}) => {
  const res = await axios.post(`/rank/all`, payload)
  return res.data
}

export const fetchRankByExchange = async (payload = {}) => {
  const res = await axios.post(`/rank/exchange`, payload)
  return res.data
}

export const fetchNewsList = async ({ page = 1, count = 5 }) => {
  const res = await axios.post(`/news/list`, { page, count })
  return res.data
}